/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type ListCustomDomainMcpEndpointsSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type ListCustomDomainMcpEndpointsRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
};

/** @internal */
export type ListCustomDomainMcpEndpointsSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const ListCustomDomainMcpEndpointsSecurity$outboundSchema: z.ZodMiniType<
  ListCustomDomainMcpEndpointsSecurity$Outbound,
  ListCustomDomainMcpEndpointsSecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function listCustomDomainMcpEndpointsSecurityToJSON(
  listCustomDomainMcpEndpointsSecurity: ListCustomDomainMcpEndpointsSecurity,
): string {
  return JSON.stringify(
    ListCustomDomainMcpEndpointsSecurity$outboundSchema.parse(
      listCustomDomainMcpEndpointsSecurity,
    ),
  );
}

/** @internal */
export type ListCustomDomainMcpEndpointsRequest$Outbound = {
  "Gram-Session"?: string | undefined;
};

/** @internal */
export const ListCustomDomainMcpEndpointsRequest$outboundSchema: z.ZodMiniType<
  ListCustomDomainMcpEndpointsRequest$Outbound,
  ListCustomDomainMcpEndpointsRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
    });
  }),
);

export function listCustomDomainMcpEndpointsRequestToJSON(
  listCustomDomainMcpEndpointsRequest: ListCustomDomainMcpEndpointsRequest,
): string {
  return JSON.stringify(
    ListCustomDomainMcpEndpointsRequest$outboundSchema.parse(
      listCustomDomainMcpEndpointsRequest,
    ),
  );
}
